var map = {
	"./Dec/tri_sector1.svg": 1668,
	"./GCSE/AnglesInACircle.jpg": 1669,
	"./GCSE/AreaEqualToDiameterCircle.jpg": 1670,
	"./GCSE/Bearings/bearingImage1.jpg": 1671,
	"./GCSE/Bearings/bearingImage2.jpg": 1672,
	"./GCSE/Bearings/bearingImage3.jpg": 1673,
	"./GCSE/Bearings/bearingImage4.jpg": 1674,
	"./GCSE/Bearings/bearingImage5.jpg": 1675,
	"./GCSE/Bearings/bearingImage6.jpg": 1676,
	"./GCSE/Bearings/bearingImage7.jpg": 1677,
	"./GCSE/Bearings/bearingImage8.jpg": 1678,
	"./GCSE/CircleTheorems/cyclic_quad1.jpg": 1679,
	"./GCSE/CircleTheorems/diameter1.jpg": 1680,
	"./GCSE/CircleTheorems/half_at_centre1.jpg": 1681,
	"./GCSE/CircleTheorems/same_segment1.jpg": 1682,
	"./GCSE/CircleTheorems/tangent1.jpg": 1683,
	"./GCSE/CircleTheorems/tangent2.jpg": 1684,
	"./GCSE/CircleTheorems/tangent3.jpg": 1685,
	"./GCSE/GCSE_Crossover_Algebra_Seai_Inequalities_Exam_Q3/numberLine1.jpg": 1686,
	"./GCSE/GCSE_Crossover_Algebra_Seai_Inequalities_Exam_Q3/numberLine10.jpg": 1687,
	"./GCSE/GCSE_Crossover_Algebra_Seai_Inequalities_Exam_Q3/numberLine2.jpg": 1688,
	"./GCSE/GCSE_Crossover_Algebra_Seai_Inequalities_Exam_Q3/numberLine3.jpg": 1689,
	"./GCSE/GCSE_Crossover_Algebra_Seai_Inequalities_Exam_Q3/numberLine4.jpg": 1690,
	"./GCSE/GCSE_Crossover_Algebra_Seai_Inequalities_Exam_Q3/numberLine5.jpg": 1691,
	"./GCSE/GCSE_Crossover_Algebra_Seai_Inequalities_Exam_Q3/numberLine6.jpg": 1692,
	"./GCSE/GCSE_Crossover_Algebra_Seai_Inequalities_Exam_Q3/numberLine7.jpg": 1693,
	"./GCSE/GCSE_Crossover_Algebra_Seai_Inequalities_Exam_Q3/numberLine8.jpg": 1694,
	"./GCSE/GCSE_Crossover_Algebra_Seai_Inequalities_Exam_Q3/numberLine9.jpg": 1695,
	"./GCSE/GCSE_Crossover_Algebra_Seai_Inequalities_Exam_Q4/numberLine1.jpg": 1696,
	"./GCSE/GCSE_Crossover_Algebra_Seai_Inequalities_Exam_Q4/numberLine10.jpg": 1697,
	"./GCSE/GCSE_Crossover_Algebra_Seai_Inequalities_Exam_Q4/numberLine2.jpg": 1698,
	"./GCSE/GCSE_Crossover_Algebra_Seai_Inequalities_Exam_Q4/numberLine3.jpg": 1699,
	"./GCSE/GCSE_Crossover_Algebra_Seai_Inequalities_Exam_Q4/numberLine4.jpg": 1700,
	"./GCSE/GCSE_Crossover_Algebra_Seai_Inequalities_Exam_Q4/numberLine5.jpg": 1701,
	"./GCSE/GCSE_Crossover_Algebra_Seai_Inequalities_Exam_Q4/numberLine6.jpg": 1702,
	"./GCSE/GCSE_Crossover_Algebra_Seai_Inequalities_Exam_Q4/numberLine7.jpg": 1703,
	"./GCSE/GCSE_Crossover_Algebra_Seai_Inequalities_Exam_Q4/numberLine8.jpg": 1704,
	"./GCSE/GCSE_Crossover_Algebra_Seai_Inequalities_Exam_Q4/numberLine9.jpg": 1705,
	"./GCSE/LadderAgainstWall.jpg": 1706,
	"./GCSE/NonRightangleTriangle/Cosine/1a.jpg": 1707,
	"./GCSE/NonRightangleTriangle/Cosine/1area.jpg": 1708,
	"./GCSE/NonRightangleTriangle/Cosine/1b.jpg": 1709,
	"./GCSE/NonRightangleTriangle/Cosine/1c.jpg": 1710,
	"./GCSE/NonRightangleTriangle/Cosine/2a.jpg": 1711,
	"./GCSE/NonRightangleTriangle/Cosine/2area.jpg": 1712,
	"./GCSE/NonRightangleTriangle/Cosine/2b.jpg": 1713,
	"./GCSE/NonRightangleTriangle/Cosine/2c.jpg": 1714,
	"./GCSE/NonRightangleTriangle/Cosine/3a.jpg": 1715,
	"./GCSE/NonRightangleTriangle/Cosine/3area.jpg": 1716,
	"./GCSE/NonRightangleTriangle/Cosine/3b.jpg": 1717,
	"./GCSE/NonRightangleTriangle/Cosine/3c.jpg": 1718,
	"./GCSE/NonRightangleTriangle/Sine/1.jpg": 1719,
	"./GCSE/NonRightangleTriangle/Sine/2.jpg": 1720,
	"./GCSE/NonRightangleTriangle/Sine/3.jpg": 1721,
	"./GCSE/NonRightangleTriangle/Sine/4.jpg": 1722,
	"./GCSE/NonRightangleTriangle/Sine/5.jpg": 1723,
	"./GCSE/NonRightangleTriangle/Sine/6.jpg": 1724,
	"./GCSE/ParallelLines/1.jpg": 1725,
	"./GCSE/ParallelLines/10.jpg": 1726,
	"./GCSE/ParallelLines/2.jpg": 1727,
	"./GCSE/ParallelLines/3.jpg": 1728,
	"./GCSE/ParallelLines/4.jpg": 1729,
	"./GCSE/ParallelLines/5.jpg": 1730,
	"./GCSE/ParallelLines/6.jpg": 1731,
	"./GCSE/ParallelLines/7.jpg": 1732,
	"./GCSE/ParallelLines/8.jpg": 1733,
	"./GCSE/ParallelLines/9.jpg": 1734,
	"./GCSE/ParallelLines/TripleParrallel.jpg": 1735,
	"./GCSE/Perimeter_and_area/3dCompound1.jpg": 1736,
	"./GCSE/Perimeter_and_area/Arrow1.jpg": 1737,
	"./GCSE/Perimeter_and_area/Arrow2.jpg": 1738,
	"./GCSE/Perimeter_and_area/Banjo1.jpg": 1739,
	"./GCSE/Perimeter_and_area/Circle1.jpg": 1740,
	"./GCSE/Perimeter_and_area/Circle1Small.jpg": 1741,
	"./GCSE/Perimeter_and_area/CircleInCircle1.jpg": 1742,
	"./GCSE/Perimeter_and_area/CompoundShape1.jpg": 1743,
	"./GCSE/Perimeter_and_area/Pentagon1.jpg": 1744,
	"./GCSE/Perimeter_and_area/Rectangle1.jpg": 1745,
	"./GCSE/Perimeter_and_area/Rectangle1_small.jpg": 1746,
	"./GCSE/Perimeter_and_area/SemiCircleInARectangle1.jpg": 1747,
	"./GCSE/Perimeter_and_area/TV1.jpg": 1748,
	"./GCSE/Perimeter_and_area/Trapezium1.jpg": 1749,
	"./GCSE/Perimeter_and_area/Trapezium2.jpg": 1750,
	"./GCSE/Perimeter_and_area/Triangle1.jpg": 1751,
	"./GCSE/Perimeter_and_area/compound1.jpg": 1752,
	"./GCSE/Perimeter_and_area/compound2.jpg": 1753,
	"./GCSE/Perimeter_and_area/compound3.jpg": 1754,
	"./GCSE/Perimeter_and_area/compound4.jpg": 1755,
	"./GCSE/Perimeter_and_area/compound5.jpg": 1756,
	"./GCSE/Perimeter_and_area/compound6.jpg": 1757,
	"./GCSE/Perimeter_and_area/cuboid1.jpg": 1758,
	"./GCSE/Perimeter_and_area/irregularShape1.jpg": 1759,
	"./GCSE/Perimeter_and_area/parallelogram1.jpg": 1760,
	"./GCSE/Perimeter_and_area/parallelogram2.jpg": 1761,
	"./GCSE/Perimeter_and_area/parallelogram3.jpg": 1762,
	"./GCSE/Perimeter_and_area/rectangle2.jpg": 1763,
	"./GCSE/Perimeter_and_area/rectangle3.jpg": 1764,
	"./GCSE/Perimeter_and_area/rectangle4.jpg": 1765,
	"./GCSE/Perimeter_and_area/square1.jpg": 1766,
	"./GCSE/Perimeter_and_area/square2.jpg": 1767,
	"./GCSE/Perimeter_and_area/square3.jpg": 1768,
	"./GCSE/Perimeter_and_area/trapezoid1.jpg": 1769,
	"./GCSE/Perimeter_and_area/triangularPrizm1.jpg": 1770,
	"./GCSE/Prisms/3x2 L.jpg": 1771,
	"./GCSE/Prisms/3x2 L.kra": 1772,
	"./GCSE/Prisms/3x2 b.jpg": 1773,
	"./GCSE/Prisms/3x2 b.kra": 1774,
	"./GCSE/Prisms/3x3 L.jpg": 1775,
	"./GCSE/Prisms/3x3 L.kra": 1776,
	"./GCSE/Prisms/3x3 minus row.jpg": 1777,
	"./GCSE/Prisms/3x3 minus row.kra": 1778,
	"./GCSE/Prisms/3x3.jpg": 1779,
	"./GCSE/Prisms/3x3.kra": 1780,
	"./GCSE/Prisms/Cuboid.jpg": 1781,
	"./GCSE/Prisms/Cuboid.kra": 1782,
	"./GCSE/Prisms/Cylinder.jpg": 1783,
	"./GCSE/Prisms/Cylinder.kra": 1784,
	"./GCSE/Prisms/L diag area.jpg": 1785,
	"./GCSE/Prisms/L diag area.kra": 1786,
	"./GCSE/Prisms/L diag.jpg": 1787,
	"./GCSE/Prisms/L diag.kra": 1788,
	"./GCSE/Prisms/Skip.jpg": 1789,
	"./GCSE/Prisms/Skip.kra": 1790,
	"./GCSE/Prisms/Triangle Area.jpg": 1791,
	"./GCSE/Prisms/Triangle Area.kra": 1792,
	"./GCSE/Prisms/Triangle Prism.jpg": 1793,
	"./GCSE/Prisms/Triangle Prism.kra": 1794,
	"./GCSE/Prisms/Two cuboids.jpg": 1795,
	"./GCSE/Prisms/Two cuboids.kra": 1796,
	"./GCSE/Prisms/U region split.jpg": 1797,
	"./GCSE/Prisms/U region split.kra": 1798,
	"./GCSE/Prisms/U region.jpg": 1799,
	"./GCSE/Prisms/U region.kra": 1800,
	"./GCSE/Prisms/U volume.jpg": 1801,
	"./GCSE/Prisms/U volume.kra": 1802,
	"./GCSE/Prisms/area L.jpg": 1803,
	"./GCSE/Prisms/area L.kra": 1804,
	"./GCSE/Prisms/area b.jpg": 1805,
	"./GCSE/Prisms/area b.kra": 1806,
	"./GCSE/ProbabilityTree/ProbabilityTree.ai": 1807,
	"./GCSE/ProbabilityTree/ProbabilityTree.jpg": 1808,
	"./GCSE/ProbabilityTree/ProbabilityTree2.jpg": 1809,
	"./GCSE/Pythagoras/3SquareTriangle.jpg": 1810,
	"./GCSE/Pythagoras/Building.jpg": 1811,
	"./GCSE/Pythagoras/Paper.jpg": 1812,
	"./GCSE/Pythagoras/RoofProblem.jpg": 1813,
	"./GCSE/Pythagoras/SimpleTriangle.jpg": 1814,
	"./GCSE/QuadAngles.jpg": 1815,
	"./GCSE/QuadLengths.jpg": 1816,
	"./GCSE/RectArea.jpg": 1817,
	"./GCSE/Rectangle1_small.jpg": 1818,
	"./GCSE/RightAngledTriangles/0.JPG": 1819,
	"./GCSE/RightAngledTriangles/1.JPG": 1820,
	"./GCSE/RightAngledTriangles/1r.JPG": 1821,
	"./GCSE/RightAngledTriangles/2.JPG": 1822,
	"./GCSE/RightAngledTriangles/3.JPG": 1823,
	"./GCSE/RightAngledTriangles/Crabs.JPG": 1824,
	"./GCSE/RightAngledTriangles/Gen Doc.odt": 1825,
	"./GCSE/RightAngledTriangles/Ladder.JPG": 1826,
	"./GCSE/RightAngledTriangles/double.JPG": 1827,
	"./GCSE/RightAngledTriangles/doubler.JPG": 1828,
	"./GCSE/RightAngledTriangles/iso.JPG": 1829,
	"./GCSE/RightAngledTriangles/isoright.JPG": 1830,
	"./GCSE/RightAngledTriangles/two.JPG": 1831,
	"./GCSE/Sector3.jpg": 1832,
	"./GCSE/Sectors/Sector1.jpg": 1833,
	"./GCSE/Sectors/Sector10.jpg": 1834,
	"./GCSE/Sectors/Sector2.jpg": 1835,
	"./GCSE/Sectors/Sector3.jpg": 1836,
	"./GCSE/Sectors/Sector4.jpg": 1837,
	"./GCSE/Sectors/Sector5.jpg": 1838,
	"./GCSE/Sectors/Sector6.jpg": 1839,
	"./GCSE/Sectors/Sector7.jpg": 1840,
	"./GCSE/Sectors/Sector8.jpg": 1841,
	"./GCSE/Sectors/Sector9.jpg": 1842,
	"./GCSE/Sectors/Segment1.jpg": 1843,
	"./GCSE/Sectors/Segment10.jpg": 1844,
	"./GCSE/Sectors/Segment2.jpg": 1845,
	"./GCSE/Sectors/Segment3.jpg": 1846,
	"./GCSE/Sectors/Segment4.jpg": 1847,
	"./GCSE/Sectors/Segment5.jpg": 1848,
	"./GCSE/Sectors/Segment6.jpg": 1849,
	"./GCSE/Sectors/Segment7.jpg": 1850,
	"./GCSE/Sectors/Segment8.jpg": 1851,
	"./GCSE/Sectors/Segment9.jpg": 1852,
	"./GCSE/Sectors/tri_sector1.jpg": 1853,
	"./GCSE/Sectors/tri_sector1.svg": 1854,
	"./GCSE/Similar/Cylinder1.jpg": 1855,
	"./GCSE/Similar/similar_cuboid.jpg": 1856,
	"./GCSE/Similar/similar_frustum.jpg": 1857,
	"./GCSE/Similar/sqbPyramid.jpg": 1858,
	"./GCSE/SimilarRectangle.jpg": 1859,
	"./GCSE/TV1.jpg": 1860,
	"./GCSE/Trapezium.jpg": 1861,
	"./GCSE/Triangle1.jpg": 1862,
	"./GCSE/Triangle2.jpg": 1863,
	"./GCSE/VennDiagrams/A.jpg": 1864,
	"./GCSE/VennDiagrams/AnotB.jpg": 1865,
	"./GCSE/VennDiagrams/B.jpg": 1866,
	"./GCSE/VennDiagrams/BigVenn.JPG": 1867,
	"./GCSE/VennDiagrams/BnotA.jpg": 1868,
	"./GCSE/VennDiagrams/Empty.jpg": 1869,
	"./GCSE/VennDiagrams/Intersection.jpg": 1870,
	"./GCSE/VennDiagrams/NotA.jpg": 1871,
	"./GCSE/VennDiagrams/NotANotB.jpg": 1872,
	"./GCSE/VennDiagrams/NotB.jpg": 1873,
	"./GCSE/VennDiagrams/TripleVenn.jpg": 1874,
	"./GCSE/VennDiagrams/Union.jpg": 1875,
	"./GCSE/bounds_cylinder1.jpg": 1876,
	"./GCSE/bounds_square1.jpg": 1877,
	"./GCSE/bounds_triangle1.jpg": 1878,
	"./GCSE/cuboid4NoCm.jpg": 1879,
	"./GCSE/surds_tri.jpg": 1880,
	"./James/BoxSlope.svg": 1881,
	"./James/ConnectedBoxes.svg": 1882,
	"./James/ConnectedBoxes2.svg": 1883,
	"./James/Cube.svg": 1884,
	"./James/Forces.svg": 1885,
	"./James/Parallelepiped.svg": 1886,
	"./James/Platform.svg": 1887,
	"./James/Pulley.svg": 1888,
	"./James/QuadraticTable.svg": 1889,
	"./Joel/Cubic_Shaded.svg": 1890,
	"./Joel/quarter_circ.svg": 1891,
	"./Leo/2Circle.svg": 1892,
	"./Leo/3Circle.svg": 1893,
	"./Leo/3Circle_ME.svg": 1894,
	"./Leo/AppliedDiff_Q6.svg": 1895,
	"./Leo/AppliedDiff_Q7.svg": 1896,
	"./Leo/BoxPlots/MCQ1/BoxPlotMCQ1_1.svg": 1897,
	"./Leo/BoxPlots/MCQ1/BoxPlotMCQ1_2.svg": 1898,
	"./Leo/BoxPlots/MCQ1/BoxPlotMCQ1_3.svg": 1899,
	"./Leo/BoxPlots/MCQ1/BoxPlotMCQ1_4.svg": 1900,
	"./Leo/BoxPlots/MCQ1/BoxPlotMCQ1_5.svg": 1901,
	"./Leo/BoxPlots/MCQ2/BoxPlotMCQ2_1.svg": 1902,
	"./Leo/BoxPlots/MCQ2/BoxPlotMCQ2_2.svg": 1903,
	"./Leo/BoxPlots/MCQ2/BoxPlotMCQ2_3.svg": 1904,
	"./Leo/BoxPlots/MCQ2/BoxPlotMCQ2_4.svg": 1905,
	"./Leo/BoxPlots/MCQ2/BoxPlotMCQ2_5.svg": 1906,
	"./Leo/BoxPlots/MCQ3/BoxPlotMCQ3_1.svg": 1907,
	"./Leo/BoxPlots/MCQ3/BoxPlotMCQ3_2.svg": 1908,
	"./Leo/BoxPlots/MCQ3/BoxPlotMCQ3_3.svg": 1909,
	"./Leo/BoxPlots/MCQ3/BoxPlotMCQ3_4.svg": 1910,
	"./Leo/BoxPlots/MCQ3/BoxPlotMCQ3_5.svg": 1911,
	"./Leo/BoxPlots/Outliers/OutliersMCQ3_1.svg": 1912,
	"./Leo/BoxPlots/Outliers/OutliersMCQ3_2.svg": 1913,
	"./Leo/BoxPlots/Outliers/OutliersMCQ3_3.svg": 1914,
	"./Leo/BoxPlots/Outliers/OutliersMCQ3_4.svg": 1915,
	"./Leo/BoxPlots/Outliers/OutliersMCQ3_5.svg": 1916,
	"./Leo/BoxPlots/Outliers/OutliersQ4_1.svg": 1917,
	"./Leo/BoxPlots/Outliers/OutliersQ4_2.svg": 1918,
	"./Leo/BoxPlots/Outliers/OutliersQ4_3.svg": 1919,
	"./Leo/BoxPlots/Outliers/OutliersQ4_4.svg": 1920,
	"./Leo/BoxPlots/Outliers/OutliersQ4_5.svg": 1921,
	"./Leo/BoxPlots/Outliers/OutliersQ5_1.svg": 1922,
	"./Leo/BoxPlots/Outliers/OutliersQ5_2.svg": 1923,
	"./Leo/BoxPlots/Outliers/OutliersQ5_3.svg": 1924,
	"./Leo/BoxPlots/Outliers/OutliersQ5_4.svg": 1925,
	"./Leo/BoxPlots/Outliers/OutliersQ5_5.svg": 1926,
	"./Leo/BoxPlots/Outliers/OutliersQ7_1.svg": 1927,
	"./Leo/BoxPlots/Outliers/OutliersQ7_2.svg": 1928,
	"./Leo/BoxPlots/Outliers/OutliersQ7_3.svg": 1929,
	"./Leo/BoxPlots/Outliers/OutliersQ7_4.svg": 1930,
	"./Leo/BoxPlots/Outliers/OutliersQ7_5.svg": 1931,
	"./Leo/BoxPlots/Q1/BoxPlotQ1_1.svg": 1932,
	"./Leo/BoxPlots/Q1/BoxPlotQ1_2.svg": 1933,
	"./Leo/BoxPlots/Q1/BoxPlotQ1_3.svg": 1934,
	"./Leo/BoxPlots/Q1/BoxPlotQ1_4.svg": 1935,
	"./Leo/BoxPlots/Q1/BoxPlotQ1_5.svg": 1936,
	"./Leo/BoxPlots/Q2/BoxPlotQ2_1.svg": 1937,
	"./Leo/BoxPlots/Q2/BoxPlotQ2_2.svg": 1938,
	"./Leo/BoxPlots/Q2/BoxPlotQ2_3.svg": 1939,
	"./Leo/BoxPlots/Q2/BoxPlotQ2_4.svg": 1940,
	"./Leo/BoxPlots/Q2/BoxPlotQ2_5.svg": 1941,
	"./Leo/BoxPlots/Q3/BoxPlotQ3_1.svg": 1942,
	"./Leo/BoxPlots/Q3/BoxPlotQ3_2.svg": 1943,
	"./Leo/BoxPlots/Q3/BoxPlotQ3_3.svg": 1944,
	"./Leo/BoxPlots/Q3/BoxPlotQ3_4.svg": 1945,
	"./Leo/BoxPlots/Q3/BoxPlotQ3_5.svg": 1946,
	"./Leo/BoxPlots/Q4/BoxPlotQ4_1.svg": 1947,
	"./Leo/BoxPlots/Q4/BoxPlotQ4_2.svg": 1948,
	"./Leo/BoxPlots/Q4/BoxPlotQ4_3.svg": 1949,
	"./Leo/BoxPlots/Q4/BoxPlotQ4_4.svg": 1950,
	"./Leo/BoxPlots/Q4/BoxPlotQ4_5.svg": 1951,
	"./Leo/BoxPlots/Q5/BoxPlotQ5_1.svg": 1952,
	"./Leo/BoxPlots/Q5/BoxPlotQ5_2.svg": 1953,
	"./Leo/BoxPlots/Q5/BoxPlotQ5_3.svg": 1954,
	"./Leo/BoxPlots/Q5/BoxPlotQ5_4.svg": 1955,
	"./Leo/BoxPlots/Q5/BoxPlotQ5_5.svg": 1956,
	"./Leo/BoxPlots/Q6/BoxPlotQ6_1.svg": 1957,
	"./Leo/BoxPlots/Q6/BoxPlotQ6_2.svg": 1958,
	"./Leo/BoxPlots/Q6/BoxPlotQ6_3.svg": 1959,
	"./Leo/BoxPlots/Q6/BoxPlotQ6_4.svg": 1960,
	"./Leo/BoxPlots/Q6/BoxPlotQ6_5.svg": 1961,
	"./Leo/BoxPlots/Q7/BoxPlotQ7_1.svg": 1962,
	"./Leo/BoxPlots/Q7/BoxPlotQ7_2.svg": 1963,
	"./Leo/BoxPlots/Q7/BoxPlotQ7_3.svg": 1964,
	"./Leo/BoxPlots/Q7/BoxPlotQ7_4.svg": 1965,
	"./Leo/BoxPlots/Q7/BoxPlotQ7_5.svg": 1966,
	"./Leo/BoxPlots/Q8/BoxPlotQ8_1.svg": 1967,
	"./Leo/BoxPlots/Q8/BoxPlotQ8_2.svg": 1968,
	"./Leo/BoxPlots/Q8/BoxPlotQ8_3.svg": 1969,
	"./Leo/BoxPlots/Q8/BoxPlotQ8_4.svg": 1970,
	"./Leo/BoxPlots/Q8/BoxPlotQ8_5.svg": 1971,
	"./Leo/TreeDiagrams/2x2.svg": 1972,
	"./Leo/TreeDiagrams/2x3.svg": 1973,
	"./Leo/TreeDiagrams/3x2.svg": 1974,
	"./Leo/TreeDiagrams/3x2_MCQ.svg": 1975,
	"./Leo/VennDiagrams_MCQ2/A.svg": 1976,
	"./Leo/VennDiagrams_MCQ2/AandB.svg": 1977,
	"./Leo/VennDiagrams_MCQ2/AorB.svg": 1978,
	"./Leo/VennDiagrams_MCQ2/AornotB.svg": 1979,
	"./Leo/VennDiagrams_MCQ2/justA.svg": 1980,
	"./Leo/VennDiagrams_MCQ2/notA.svg": 1981,
	"./Leo/bucket.svg": 1982,
	"./Leo/campingset.svg": 1983,
	"./Leo/map.svg": 1984,
	"./Matt/2.svg": 1985,
	"./Matt/SUVATGraph1.svg": 1986,
	"./Matt/boxOnInclinedPlane1.svg": 1987,
	"./Matt/boxOnInclinedPlane2.svg": 1988,
	"./Matt/boxOnPlane1.svg": 1989,
	"./Matt/circleInsideSquare.svg": 1990,
	"./Matt/exactValueTriangle1.svg": 1991,
	"./Matt/exactValueTriangle2.svg": 1992,
	"./Matt/exactValueTriangle3.svg": 1993,
	"./Matt/forcesActingOnParticle1.svg": 1994,
	"./Matt/forcesActingOnParticle2.svg": 1995,
	"./Matt/forcesActingOnParticle3.svg": 1996,
	"./Matt/freeBodyPulleyProblem1.svg": 1997,
	"./Matt/hangingMassProblem1.svg": 1998,
	"./Matt/irregularTriangle1.svg": 1999,
	"./Matt/irregularTriangle2.svg": 2000,
	"./Matt/irregularTriangle3.svg": 2001,
	"./Matt/irregularTriangle4.svg": 2002,
	"./Matt/massHangingFromStringsProblem1.svg": 2003,
	"./Matt/mcqMomentDiagram1.svg": 2004,
	"./Matt/mcqMomentDiagram2.svg": 2005,
	"./Matt/mcqMomentDiagram3.svg": 2006,
	"./Matt/projectileDiagram1.svg": 2007,
	"./Matt/projectileDiagram2.svg": 2008,
	"./Matt/projectileDiagram3.svg": 2009,
	"./Matt/rectangleOnPlane1.svg": 2010,
	"./Matt/rightAngleTriangle1.svg": 2011,
	"./Matt/rightAngleTriangle2.svg": 2012,
	"./Matt/rightAngleTriangle3.svg": 2013,
	"./Matt/rightAngleTriangle4.svg": 2014,
	"./Matt/sector1.svg": 2015,
	"./Matt/sector2.svg": 2016,
	"./Matt/sector3.svg": 2017,
	"./Matt/sector4.svg": 2018,
	"./Matt/table1.svg": 2019,
	"./Matt/triangle1.svg": 2020,
	"./Matt/triangle2.svg": 2021,
	"./Matt/trigProofs1.svg": 2022,
	"./Matt/trigonometryProblem1.svg": 2023,
	"./Matt/twoBoxesOnHoriztonalPlane1.svg": 2024
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1667;